import './Final.css';
import { Avatar } from '../../../components/Avatar/Avatar';
import { Bank } from '../components/Bank/Bank';
export const Final = () => {
    return (
        <div className="classic__final">
            <div className="classic__final-up-container">
                <div className="classic__final-user-container">
                    <div className="classic__final-user-background">
                        <Avatar />
                    </div>
                    <span className="classic__final-user-name">Pretty007 csgetto.cash</span>
                    <span className="classic__final-user-victory">победил!</span>
                    <span className="classic__final-team-text">Бандa(sdfsdf)</span>
                </div>
            </div>
            <span className="classic__final-border"></span>
            <div className="classic__final-down-container">
                <div className="classic__final-ticket">
                    <span className="classic__final-ticket-text">Шанс</span>
                    <span className="classic__final-ticket-percent">33.33%</span>
                </div>
                <Bank />
                <div className="classic__final-ticket">
                    <span className="classic__final-ticket-text">Билет</span>
                    <span className="classic__final-ticket-percent">№101</span>
                </div>
            </div>
            <span className="classic__final-ticket-text classic__final-ticket-id-text">
                B61C5BFA521BD637289EB33B00B8E5331315EA2171092D9E0FDA46E05881DD7C
            </span>
        </div>
    );
};
